import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useAuth from '../../hooks/useAuth';
import useGoogleStatistics from '../../hooks/useGoogleStatistics';
import useIsAuthenticated from '../../hooks/useIsAuthenticated';
import Header from './Header';
import Footer from '../Footer';
import SocialBar from './SocialBar';
import ReactLoader from '../ReactLoader';
import ScrollToTop from '../helpers/ScrollToTop';
import Head from './Head';

function AppLayout() {
  const { isLoading } = useSelector((store) => store.defaultReducer);
  useAuth();
  useGoogleStatistics();

  const { isUserLoggedIn } = useIsAuthenticated();

  React.useEffect(() => {
    if (isUserLoggedIn) {
      const searchParams = new URLSearchParams(window.location.search);
      const redirectTo = searchParams.get('redirectTo');
      if (redirectTo) {
        window.location.href = redirectTo;
      }
    }
  }, [isUserLoggedIn]);

  return (
    <>
      <Head />
      <ScrollToTop />
      <Header />
      <SocialBar />
      <Outlet />
      <Footer />
      {isLoading && <ReactLoader />}
    </>
  );
}

export default AppLayout;


